export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.654 2.004A3 3 0 0116.5 5v1H19a1 1 0 01.982.812l2.042 10.622A3 3 0 0119.08 21H4.921a3 3 0 01-2.945-3.566L4.018 6.812l.021-.087A1 1 0 015 6h2.5V5a3 3 0 013-3h3l.154.004zM3.94 17.81A1 1 0 004.921 19h14.158a1 1 0 00.982-1.189L18.174 8H5.826L3.94 17.811zM10.5 4a1 1 0 00-1 1v1h5V5a1 1 0 00-.898-.995L13.5 4h-3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};